import { Tag } from 'antd'
import {
    CUSTOMER_UPLOAD,
    DFM_REPORT_BY_FICTIV_ENGINEER,
    FICTIV_UPLOAD,
    SOURCE_FICTIV,
} from '@Admin/AdminQuotingPage/constants'

import Tooltip from '~/core/Tooltip'
import Text from '~/core/Text'
import { AdminQuoteModelRevisionDfmReportFragment as DFMReportsType } from '~/gql/graphql'

type UploadSourceTagType = {
    dfmReport: DFMReportsType
    isAdminQuotingPage?: boolean
}

export default function UploadSourceTag(props: UploadSourceTagType) {
    const { dfmReport, isAdminQuotingPage } = props

    const showTooltip =
        dfmReport.source === SOURCE_FICTIV && !isAdminQuotingPage

    const SourceTag = () => {
        return (
            <Tag
                color={dfmReport?.source === SOURCE_FICTIV ? 'cyan' : 'blue'}
                style={{
                    fontSize: '12px',
                    fontWeight: 400,
                }}
            >
                {dfmReport?.source === SOURCE_FICTIV
                    ? FICTIV_UPLOAD
                    : CUSTOMER_UPLOAD}
            </Tag>
        )
    }

    if (showTooltip) {
        return (
            <Tooltip
                title={DFM_REPORT_BY_FICTIV_ENGINEER}
                overlayStyle={{ maxWidth: '320px' }}
                placement="topLeft"
            >
                <Text>
                    <SourceTag />
                </Text>
            </Tooltip>
        )
    }
    return <SourceTag />
}
